import { call, put, takeLatest, select } from "redux-saga/effects";
import type { PayloadAction } from "@reduxjs/toolkit";
import UserTransactionService from "services/api.services/UserTransaction/UserTransactionService";
import {
  FetchTransactionsPayload,
  fetchTransactionsFailure,
  fetchTransactionsSuccess,
  fetchTransactionsRequest,
} from "./userTransactionSlice";
import { TransactionPageResponse } from "./userTransactionType";
import { RootState } from "store/rootReducer";

// type RootState = any;  // replace with your RootState import if available

function* handleFetchTransactions(
  action: PayloadAction<FetchTransactionsPayload>,
) {
  try {
    const state: RootState = yield select((s: RootState) => s);

    const pageNumber = action.payload.pageNumber ?? 1;
    const pageSize =
      action.payload.pageSize ?? state.transactions?.pageSize ?? 10;
    const mode = action.payload.mode ?? "replace";

    const res: TransactionPageResponse = yield call(
      UserTransactionService.getUserTransactions,
      {
        pageNumber,
        pageSize,
      },
    );

    if (!res?.status || !res?.data) {
      const msg = res?.message || "API returned unsuccessful response.";
      yield put(fetchTransactionsFailure(msg));
      return;
    }

    yield put(
      fetchTransactionsSuccess({
        mode,
        items: res.data.transactions || [],
        pageNumber: res.data.pageNumber,
        pageSize: res.data.pageSize,
        totalCount: res.data.totalCount,
        totalPages: res.data.totalPages,
        hasNext: res.data.hasNext,
        hasPrev: res.data.hasPrev,
        message: res.message,
      }),
    );
  } catch (e: any) {
    yield put(
      fetchTransactionsFailure(e?.message || "Failed to fetch transactions."),
    );
  }
}

export function* transactionsSaga() {
  yield takeLatest(fetchTransactionsRequest.type, handleFetchTransactions);
}
